<template>
  <div class="memberContainer">
    <nav-bar style="width: 100%" :type="type" />

    <div class="innerContainerVideo">
      <div class="editContainer">
        <div class="tabContainer">
          <div
            class="tabs"
            :class="{ tabActive: tabActive == 0 }"
            @click="tabActive = 0"
          >
            发布视频
          </div>
          <div
            class="tabs"
            :class="{ tabActive: tabActive == 1 }"
            @click="tabActive = 1"
          >
            {{ this.$route.query.nvpl_series_id ? "编辑" : "创建" }}合集
          </div>
        </div>
        <div class="singleVideoContainer" v-show="tabActive == 0">
          <div style="width: 100%">
            <div
              class="coverChangeBtn"
              v-if="previewThumb"
              @click="coverChangeOpen"
            >
              更换封面
            </div>
            <video
              style="width: 100%; object-fit: contain; height: 100%"
              :src="videoSrc"
              :poster="previewThumb"
              controls
              v-if="videoSrc && !isNewUpload"
            ></video>
            <div
              class="get-cover"
              v-if="videoSrc && isNewUpload"
              :class="{ horizontalThumb: is_horizontal == 2 }"
            >
              <p v-if="!previewThumb">视频转码中，可正常提交</p>
              <img
                src="../../assets/videoIcon.png"
                class="videoIcon"
                v-if="previewThumb"
              />
              <img :src="previewThumb" class="videoCover" v-if="previewThumb" />
              <div class="tip" v-if="previewThumb">
                视频转码期间不支持播放，可正常提交
              </div>
            </div>
            <el-upload
              drag
              action="no"
              accept="video/*"
              :before-upload="onBeforeUpload"
              :http-request="uploadFn"
              class="uploadElemBox"
            >
              <p style="color: #333; font-size: 24px">
                <img
                  style="width: 89px; height: 89px"
                  src="../../assets/script/sc.png"
                />
                <br />
                <br />
                <span>点击上传或拖拉至边框内</span>
              </p>
            </el-upload>
          </div>

          <div class="titleContain">
            <div class="titleLabelContain">
              <p class="titleLabel">添加标题</p>
              <!-- <p class="titleAiOutBtn" @click.stop="aiTitleShowFn()">
                标题推荐
              </p>
              <el-popover
                placement="bottom"
                width="461"
                trigger="manual"
                popper-class="titleAiContain"
                v-model="aiTitleShow"
                style="margin-left: 30px; margin-top: -20px"
              >
                <ul class="aiTitleList" v-loading="aiTitleLoading">
                  <li
                    class="aiTitleItem"
                    v-for="(item, index) in aiTitle"
                    :key="index"
                    @click="aiTitleSelect(item)"
                  >
                    <p class="aiTitleLabel">标题{{ index + 1 }}：</p>
                    <p class="aiTitleContent">{{ item }}</p>
                  </li>
                </ul>
              </el-popover> -->
            </div>
            <el-input
              style="width: 100%; margin-bottom: 0; margin-right: 0"
              v-model="title"
              placeholder="请输入标题(2-30字)"
              clearable
              maxlength="30"
              show-word-limit
            ></el-input>
          </div>

          <div class="contentContain">
            <p class="titleLabel">添加简介</p>
            <img
              src="../../assets/topic.png"
              class="topicBtn"
              title="插入话题"
              @click="insertTopic"
            />
          </div>

          <div class="topicListContainer" v-show="topicList.length">
            <div
              v-for="(item, index) in topicList"
              :key="index"
              class="topicList"
              @click="deleteTopic(index)"
            >
              #{{ item }}#
            </div>
          </div>

          <div>
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入视频简介"
              v-model="content"
              resize="none"
              maxlength="400"
              show-word-limit
            >
            </el-input>
          </div>
        </div>
        <div
          class="videoCollectionContainer"
          v-show="tabActive == 1 && collectionRight"
        >
          <div class="collectionInputContainer">
            <p class="label"><span class="requireIcon">*</span>合集标题</p>
            <el-input
              v-model="collectionTitle"
              placeholder="请输入标题"
              clearable
              maxlength="70"
              show-word-limit
            ></el-input>
          </div>
          <div
            class="collectionInputContainer"
            style="align-items: start; margin-top: 32px"
          >
            <p class="label"><span class="requireIcon">*</span>合集封面</p>
            <el-upload
              action="no"
              accept="image/*"
              :before-upload="onBeforeUploadThumb"
              :http-request="uploadThumbFn"
              :show-file-list="false"
              class="thumbImgUploader"
            >
              <img :src="collectionThumb" class="thumbImg" />
            </el-upload>
          </div>
          <p class="thumbAlert">
            支持jpg、jpeg、png、GIF格式，大小2MB以内，建议比例4：3
          </p>
          <div class="collectionInputContainer">
            <p class="label"><span class="requireIcon">*</span>合集视频</p>
            <div class="submitBtn" @click="openVideos">添加视频</div>
          </div>
          <draggable
            class="scriptList"
            v-model="collectionList"
            @end="onDragEnd"
          >
            <div
              v-for="(item, index) in collectionList"
              :key="index"
              class="scriptListItem"
            >
              <div class="cover-container" v-if="item.n_cover_url.length > 0">
                <el-image
                  class="cover"
                  fit="cover"
                  :src="item.n_cover_url[0]"
                  :preview-src-list="item.n_cover_url"
                />
              </div>
              <div class="info-box">
                <div class="infoContainer">
                  <p class="title" @click="toDetail(item)">
                    {{ item.n_title }}
                  </p>
                  <p class="create-time">{{ item.n_publish_time }}</p>
                </div>
                <div class="infoContainer action-bar">
                  <div class="ext-info">
                    <span>展现 {{ item.sum_watch_num }}</span>
                    <span>评论 {{ item.ndr_comment_num }}</span>
                    <span>点赞 {{ item.sum_like_num }}</span>
                  </div>
                  <div class="actionContainer">
                    <p class="btns" @click="deleteCollect(index)">
                      <span>移除合集</span>
                    </p>
                    <p class="btns">
                      <el-popover
                        placement="top"
                        width="260"
                        v-model="item.visible"
                        @show="sortShow(index)"
                      >
                        <p>当前顺序第{{ index + 1 }}位</p>
                        <p>
                          更改为第<el-input
                            v-model="item.indexChange"
                            placeholder=""
                            type="number"
                            style="width: 80px; height: 25px; margin: 10px 10px"
                          ></el-input
                          >位
                        </p>
                        <div style="text-align: right; margin: 20px 0 0 0">
                          <el-button
                            size="mini"
                            type="text"
                            @click="item.visible = false"
                            >取消</el-button
                          >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="sortSubmit(item, index)"
                            >确定</el-button
                          >
                        </div>
                        <span slot="reference">更改顺序</span>
                      </el-popover>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
          <div class="collectionSubmitContainer">
            <div class="collectionSubmitContainerInner">
              <el-button
                type="primary"
                class="submitBtn"
                @click="submitCollection()"
                >{{
                  this.$route.query.nvpl_series_id ? "编辑" : "创建"
                }}合集</el-button
              >
            </div>
          </div>
        </div>
        <div
          class="noCollectionRight"
          v-show="tabActive == 1 && !collectionRight"
        >
          <img src="../../assets/level/noRight.png" class="noRightIcon" />
          <p class="rightWarning">您当前还未到达Lv2，暂时无法使用哦～</p>
          <p class="toRights" @click="toRights()">立即提升等级></p>
        </div>
      </div>

      <div
        class="right"
        :style="{ visibility: tabActive == 0 ? 'visible' : 'hidden' }"
      >
        <info-set
          :title="title"
          :content="content"
          :resource_url="resource_url"
          :material_ids="material_ids"
          :topicIds="topicIds"
          :video_id="video_id"
          :originThumb="originThumb"
          :videoCover="previewThumb"
          :is_horizontal="is_horizontal"
          :video_length="videoDuration"
          type="2"
          @sendRight="getRight"
        />
      </div>
    </div>

    <el-dialog
      title="添加视频到合集中"
      :visible.sync="collectionAddVisible"
      width="1000px"
      top="5vh"
      class="collectionAddContainer"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="collectionAddKeyword"
        placeholder="请输入关键词"
        clearable
        class="collectionAddKeyword"
        @keyup.enter.native="getVideoList(1)"
        @clear="openVideos"
      ></el-input>
      <el-button type="primary" @click="getVideoList(1)">查 询</el-button>
      <div class="videoCollectContainer publicScroll">
        <div
          v-for="(item, index) in collectionAddList"
          :key="index"
          class="scriptListItem"
        >
          <el-checkbox
            v-model="item.checked"
            @change="(checked) => handleCheckVideo(checked, item)"
          ></el-checkbox>
          <div class="bgContainer">
            <div class="cover-container" v-if="item.n_cover_url.length > 0">
              <el-image
                class="cover"
                fit="cover"
                :src="item.n_cover_url[0]"
                :preview-src-list="item.n_cover_url"
              />
            </div>
            <div class="info-box">
              <div class="infoContainer">
                <p class="title" @click="toDetail(item)">
                  {{ item.n_title }}
                </p>
              </div>
              <p class="create-time">发布于{{ item.n_create_time }}</p>
              <div class="infoContainer action-bar">
                <div class="ext-info">
                  <span>展现 {{ item.sum_watch_num }}</span>
                  <span>评论 {{ item.ndr_comment_num }}</span>
                  <span>点赞 {{ item.sum_like_num }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="searchNoDataContainer" v-if="collectionAddList.length == 0">
        <img src="../../assets/script/no.png" class="noDataImg" />
        <p class="noDataText">暂无数据</p>
      </div>
      <el-pagination
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click="collectionAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideosFn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="预览"
      :visible.sync="previewVisible"
      width="320px"
      top="5vh"
      class="previewContainer"
    >
      <video :src="videoSrc" controls v-show="videoSrc"></video>
      <div class="info">
        <img :src="u_avatar" />
        <div>
          <p class="userName">{{ u_nickname }}</p>
          <p class="time">{{ getNowTime() }}</p>
        </div>
      </div>
      <p class="title">{{ title }}</p>
      <div>{{ content }}</div>
      <img
        src="../../assets/script/close.png"
        class="closeBtn"
        @click="previewVisible = false"
      />
    </el-dialog>

    <div class="tinymce-upload-progress-box" v-show="isUploading">
      <el-progress
        class="tinymce-upload-progress"
        type="circle"
        :percentage="progressPercent"
      ></el-progress>
    </div>

    <el-dialog
      title="插入话题"
      :visible.sync="insertTopicVisible"
      width="600px"
      class="insertTopicContainer"
    >
      <el-select
        v-model="topicValue"
        filterable
        remote
        default-first-option
        placeholder="请输入或者选择话题"
        :remote-method="getTopicList"
        @change="topicInputChange"
      >
        <el-option
          v-for="item in topicOptions"
          :key="item.id"
          :label="item.title"
          :value="item.id"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 550px;
          "
        >
          <span v-if="item.is_official == 1" style="color: #ea0e0e">(官方)</span
          >{{ item.title }}
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertTopicVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="insertTopicFn">确定</div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="videoThumbVisible"
      width="1000px"
      class="videoCoverContainer"
    >
      <div class="videoCoverTabs">
        <div
          class="videoCoverTab"
          :class="{ videoCoverTabActive: videoCoverTabIndex == 0 }"
          @click="videoCoverTabIndex = 0"
          v-if="video_id"
        >
          封面截取
        </div>
        <div
          class="videoCoverTab"
          :class="{ videoCoverTabActive: videoCoverTabIndex == 1 }"
          @click="videoCoverTabIndex = 1"
        >
          本地上传
        </div>
      </div>
      <div
        class="videoCutCoverContainer"
        v-if="videoCoverTabIndex == 0"
        v-loading="videoCutCover.length == 0"
        element-loading-text="封面截取中..."
      >
        <div
          class="videoCutCoverBox"
          :class="{ videoCutCoverActive: videoCoverChooseIndex == index }"
          v-for="(item, index) in videoCutCover"
          :key="index"
          @click="videoCoverChooseIndex = index"
        >
          <el-image class="videoCutCover" fit="cover" :src="item"> </el-image>
        </div>
      </div>
      <div class="videoUploadCoverContainer" v-if="videoCoverTabIndex == 1">
        <el-upload
          drag
          action="no"
          accept="image/*"
          :before-upload="onBeforeUploadCover"
          :http-request="uploadCoverFn"
          :show-file-list="false"
          class="uploadVideoCoverBox"
        >
          <img
            src="../../assets/script/sc.png"
            class="uploadIcon"
            v-if="!videoCoverUpload"
          />
          <img
            :src="videoCoverUpload"
            class="videoCoverUpload"
            v-if="videoCoverUpload"
          />
        </el-upload>
        <p class="uploadText">点击上传或拖拉至边框内</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="videoThumbVisible = false">取 消</div>
        <div class="submitBtn" type="primary" @click="thumbSubmit">下一步</div>
      </div>
    </el-dialog>

    <el-dialog
      title="封面剪裁"
      :visible.sync="dialogVisible"
      top="2vh"
      class="thumbCutContainer"
      width="900px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="!isNewCover"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div
          class="submitBtn"
          @click="dialogVisible = false"
          v-if="!isNewCover"
        >
          取 消
        </div>
        <div class="submitBtn" type="primary" @click="coverCutFinish">确认</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "../../components/NavBarForEdit";
import InfoSet from "./components/InfoSet";
import {
  RESOURCE_HOST,
  NEWS_HOST,
  SWNEWS_HOST,
  MEDIA_HOST,
  HSUPLOAD_HOST,
} from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";
import draggable from "vuedraggable";
import { VueCropper } from "vue-cropper";

export default {
  data() {
    return {
      belong_id: "",
      title: "",
      content: "",
      activeName: "first",
      videoSrc: "",
      sourceIndex: -1,
      sourceList: [],
      video_id: "",
      video_id_now: "",
      page: 1,
      material_ids: "",
      resource_url: [],
      originThumb: "",
      previewVisible: false,
      u_avatar: "",
      u_nickname: "",
      type: 2,
      progressPercent: 0,
      isUploading: false,
      topicList: [],
      topicIds: [],
      tabActive: 0,
      collectionTitle: "",
      collectionThumb: require("../../assets/script/uploadF.png"),
      collectionList: [],
      collectionAddVisible: false,
      collectionAddList: [],
      pageSize: 20,
      currentPage: 1,
      total: 1,
      collectionAddKeyword: "",
      currentAddKeyword: "",
      collectionAddChecks: [],
      previewThumb: "",
      previewThumbNow: "",
      getThumbT: "",
      isNewUpload: true,
      insertTopicVisible: false,
      topicOptions: [],
      topicValue: "",
      videoThumbVisible: false,
      videoCoverTabIndex: 0,
      videoCutCover: [],
      videoCoverChooseIndex: -1,
      videoCoverUpload: "",
      dialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 900, // 默认生成截图框宽度
        autoCropHeight: 700, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [4, 3], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true,
        height: false, //是否按照设备的dpr 输出等比例图片
        enlarge: 2, //图片根据截图框输出比例倍数
      },
      isNewCover: false,
      is_horizontal: 1,
      aiTitle: ["", "", ""],
      aiTitleShow: false,
      aiTitleLoading: false,
      collectionRight: false,
      belong_id_Pack: "",
      videoDuration: 0,
    };
  },
  components: {
    NavBar,
    InfoSet,
    draggable,
    VueCropper,
  },
  filters: {},
  created() {
    this.u_avatar = localStorage.getItem("u_avatar")
      ? localStorage.getItem("u_avatar")
      : require("../../assets/moren.png");
    this.u_nickname = localStorage.getItem("u_nickname");

    let body = document.getElementsByTagName("body")[0];
    body.onclick = () => {
      this.aiTitleShow = false;
    };

    if (this.$route.query.draftId) {
      this.belong_id = this.$route.query.draftId;
      this.getDraftDetail();
    } else if (this.$route.query.scriptId) {
      this.belong_id = this.$route.query.scriptId;
      this.getScriptDetail();
    } else if (this.$route.query.materialId) {
      this.belong_id = this.$route.query.materialId;
      console.log("mid", this.belong_id);
      this.material_ids = this.belong_id + "";
      this.getMaterialDetail();
    } else if (this.$route.query.dhyId) {
      this.belong_id = this.$route.query.dhyId;
      this.getDhyDetail();
    } else if (this.$route.query.nvpl_series_id) {
      this.belong_id_Pack = this.$route.query.nvpl_series_id;
      this.tabActive = 1;
      this.getCollectionDetail();
    } else if (this.$route.query.isPack) {
      this.tabActive = 1;
    } else if (this.$route.query.mediaId) {
      this.belong_id = this.$route.query.mediaId;
      this.getMediaDetail();
    }

    this.getMaterialList();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    clearInterval(this.getThumbT);
    next();
  },
  beforeDestory() {
    clearInterval(this.getThumbT);
  },
  methods: {
    getNowTime() {
      var date = new Date();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return (
        month +
        "月" +
        date.getDate() +
        "日 " +
        date.getHours() +
        ":" +
        date.getMinutes()
      );
    },
    backFn() {
      this.$confirm("您还未保存页面内容，确认离开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    },
    getDraftDetail() {
      this.$axios
        .get(`${RESOURCE_HOST}/api/draft/show?id=${this.belong_id}`)
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.nd_title;
            this.content = detail.nd_content;
            if (detail.nd_resource_url.length) {
              this.videoSrc = detail.nd_resource_url[0];
              this.resource_url = [this.videoSrc];
              this.isNewUpload = false;
              if (detail.nd_cover_url.length) {
                this.previewThumb = detail.nd_cover_url[0];
                this.previewThumbNow = detail.nd_cover_url[0];
              }
            }
            this.video_id = detail.nd_video_id;
            this.video_id_now = detail.nd_video_id;
            this.videoDuration = detail.nd_video_length;
            if (this.video_id) {
              this.getThumbs(this.video_id);
            } else {
              this.videoCoverTabIndex = 1;
            }
            this.is_horizontal = detail.nd_is_horizontal;

            this.getTopics(detail.global_id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getScriptDetail() {
      this.$axios
        .get(
          this.$route.query.isPub == 1
            ? `${SWNEWS_HOST}/api/news/getNewsInfo?id=${this.$route.query.nid}`
            : `${RESOURCE_HOST}/api/manuscript/show?id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (this.$route.query.isPub == 1) {
              for (let key in res.data.data) {
                if (key.indexOf("n_") >= 0 && key != "n_id") {
                  res.data.data[key.replace("n_", "nm_")] = res.data.data[key];
                }
              }
            }

            let detail = res.data.data;
            this.title = detail.nm_title;
            this.content = detail.nm_content;
            if (detail.nm_resource_url.length) {
              this.videoSrc = detail.nm_resource_url[0];
              this.resource_url = [this.videoSrc];
              this.isNewUpload = false;
              if (detail.nm_cover_url.length) {
                this.previewThumb = detail.nm_cover_url[0];
                this.previewThumbNow = detail.nm_cover_url[0];
              }
            }
            this.video_id = detail.nm_video_id;
            this.video_id_now = detail.nm_video_id;
            this.videoDuration = detail.nm_video_length;
            if (this.video_id) {
              this.getThumbs(this.video_id);
            } else {
              this.videoCoverTabIndex = 1;
            }
            this.is_horizontal = detail.nm_is_horizontal;

            this.getTopics(detail.global_id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getMaterialDetail() {
      this.$axios
        .post(`${RESOURCE_HOST}/api/material/showChild`, {
          id: this.belong_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            if (detail.cm_type == 3) {
              this.videoSrc = detail.cm_url;
              this.resource_url = [this.videoSrc];
              this.isNewUpload = false;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getDhyDetail() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/common/cloudnews/getTmpInfo?big_cloud_id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.n_title;
            this.content = detail.n_content.substr(0, 400);
            try {
              detail.n_resource_url = eval("(" + detail.n_resource_url + ")");
            } catch (error) {}
            if (detail.n_resource_url.length) {
              this.videoSrc = detail.n_resource_url[0];
              this.resource_url = [this.videoSrc];
              this.isNewUpload = false;
              if (detail.n_cover_url.length) {
                this.previewThumb = detail.n_cover_url[0];
                this.previewThumbNow = detail.n_cover_url[0];
              }
            }
            this.videoCoverTabIndex = 1;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getMediaDetail() {
      this.$axios
        .get(
          `${MEDIA_HOST}/biz/outer/news/queryBy?id=${this.belong_id}&&appId=${this.$route.query.appId}&&orgId=${this.$route.query.orgId}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.nmTitle;
            this.content = detail.newsContent
              ? detail.newsContent.substr(0, 400)
              : "";
            this.videoSrc = detail.nmResourceUrls[0];
            this.resource_url = [this.videoSrc];
            this.isNewUpload = false;
            this.previewThumb = detail.nmCoverUrls[0];
            this.previewThumbNow = detail.nmCoverUrls[0];
            this.videoCoverTabIndex = 1;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleClick() {
      if (this.activeName == "first") {
        this.material_ids = "";
        if (this.videoSrc) {
          this.resource_url = [this.videoSrc];
          this.video_id = this.video_id_now;
        }
        this.previewThumb = this.previewThumbNow;
      } else if (this.sourceIndex >= 0) {
        this.material_ids = this.sourceList[this.sourceIndex].cm_id + "";
        this.resource_url = [this.sourceList[this.sourceIndex].cm_url];
        this.video_id = "";
        this.previewThumb = this.sourceList[this.sourceIndex].cm_icon_url;
      }
    },
    onBeforeUpload(file) {
      this.material_ids = "";

      const isVIDEO = file.type.indexOf("video/") >= 0;
      if (!isVIDEO) {
        this.$message.error("请上传符合规格的视频格式！");
        return false;
      } else {
        this.uploadProgress(true);
        return true;
      }
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.uploadProgress(false);

          this.videoSrc = data.videoUri;
          this.resource_url = [data.videoUri];
          this.video_id = data.Vid;
          this.video_id_now = data.Vid;
          this.originThumb = data.PosterUri;
          this.previewThumb = data.PosterUri;
          this.previewThumbNow = data.PosterUri;
          this.videoCutCover = [];
          this.is_horizontal =
            data.SourceInfo.Width >= data.SourceInfo.Height ? 1 : 2;
          this.videoDuration = Math.ceil(data.SourceInfo.Duration);

          this.isNewUpload = true;

          this.isNewCover = true;

          this.option.img = this.previewThumb;
          this.dialogVisible = true;
          this.option.fixedNumber =
            this.is_horizontal == 2 ? [166, 243] : [16, 9];
          if (this.$refs.cropper) {
            this.$refs.cropper.reload();
          }

          this.getThumbs(data.Vid);
        },
        (error) => {
          console.log(error);
        },
        (processPercent) => {
          this.progressPercent = Math.floor(processPercent);
        }
      );
    },
    onBeforeUploadCover(file) {
      const isIMAGE = file.type.indexOf("image/") >= 0;
      if (!isIMAGE) {
        this.$message.error("请上传图片！");
        return false;
      } else {
        return true;
      }
    },
    uploadCoverFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.videoCoverUpload = data.url;
        },
        (error) => {},
        (processPercent) => {}
      );
    },
    coverChangeOpen() {
      if (this.video_id) {
        this.videoCoverTabIndex = 0;
      }
      this.videoCoverChooseIndex = -1;
      this.videoCoverUpload = this.previewThumb;
      this.option.img = this.previewThumb;
      this.option.fixedNumber = this.is_horizontal == 2 ? [166, 243] : [16, 9];
      if (this.$refs.cropper) {
        this.$refs.cropper.reload();
      }
      this.videoThumbVisible = true;
    },
    getThumbs(videoId) {
      this.$axios
        .get(`${HSUPLOAD_HOST}/api/upload/vod/snapshotsList?vid=${videoId}`)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.length != 0) {
              this.videoCutCover = res.data.data;
            } else {
              setTimeout(() => {
                this.getThumbs(videoId);
              }, 1000);
            }
          }
        });
    },
    thumbSubmit() {
      if (this.videoCoverTabIndex == 0) {
        if (this.videoCoverChooseIndex == -1) {
          this.$message({
            showClose: true,
            message: "请选择封面",
            type: "warning",
          });
          return;
        } else {
          this.option.img = this.videoCutCover[this.videoCoverChooseIndex];
        }
      } else {
        if (!this.videoCoverUpload) {
          this.$message({
            showClose: true,
            message: "请上传封面",
            type: "warning",
          });
          return;
        } else {
          this.option.img = this.videoCoverUpload;
        }
      }
      this.videoThumbVisible = false;
      this.dialogVisible = true;
      this.option.fixedNumber = this.is_horizontal == 2 ? [166, 243] : [16, 9];
      if (this.$refs.cropper) {
        this.$refs.cropper.reload();
      }
    },
    coverCutFinish() {
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], "1.jpg", { type: "image/jpeg" });
        HS_upload(
          file,
          (data) => {
            this.isNewCover = false;
            this.dialogVisible = false;
            this.previewThumb = data.url;
            this.previewThumbNow = data.url;
          },
          (error) => {
            console.log("error:" + error);
          },
          (processPercent) => {
            console.log("processPercent:" + processPercent);
          }
        );
      });
    },
    getMaterialList() {
      this.$axios
        .post(`${RESOURCE_HOST}/api/material/list`, {
          cm_type: 3,
          all: 1,
          page: this.page,
          cm_check: 2,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.sourceList = this.sourceList.concat(
              res.data.data.data ? res.data.data.data : []
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    loadMore() {
      this.page++;
      this.getMaterialList();
    },
    sourceFn(index) {
      this.sourceIndex = index;
      this.material_ids = this.sourceList[index].cm_id + "";
      this.resource_url = [this.sourceList[this.sourceIndex].cm_url];
      this.video_id = "";
      this.previewThumb = this.sourceList[this.sourceIndex].cm_icon_url;
    },
    uploadProgress(show) {
      let dialog = $(".tinymce-upload-progress-box");
      let progress = $(".tinymce-upload-progress");
      let progressBar = $('<div class="progress-bar"></div>');
      let sourceBox = $(".tinymce-upload-progress-box");
      if (show) {
        this.progressPercent = 0;
        this.isUploading = true;
        progressBar.append(progress);
        dialog.append(progressBar);
        progress.show();
      } else {
        this.isUploading = false;
        progress.hide();
        sourceBox.append(progress);
        progressBar.remove();
      }
    },
    insertTopic() {
      this.topicValue = "";
      this.getTopicList("");
      this.insertTopicVisible = true;
    },
    getTopicList(keyword) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/search?title=${keyword}&page=1&size=50`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.title = element.title.replace(/#/gi, "");
              if (element.id == 0) {
                element.title += "--点击添加新话题";
                element.id = element.title;
              }
            });
            this.topicOptions = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    topicInputChange(val) {
      if (typeof this.topicValue == "string") {
        this.topicValue = this.topicValue.replace(/--点击添加新话题/gi, "");
      }
    },
    insertTopicFn() {
      if (typeof this.topicValue == "string" && this.topicValue == "") {
        this.$message({
          message: "话题不能为空",
          type: "warning",
        });
      } else if (typeof this.topicValue == "string") {
        if (this.topicValue.length > 30) {
          this.$message({
            message: "话题长度不能超过30个字",
            type: "warning",
          });
          return;
        }
        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/add`, {
            title: "#" + this.topicValue + "#",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.checkTopic(res.data.data.id)) {
                this.$message({
                  message: "不能添加重复话题",
                  type: "warning",
                });
              } else {
                this.topicList.push(this.topicValue);
                this.topicIds.push(res.data.data.id);
                this.insertTopicVisible = false;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.checkTopic(this.topicValue)) {
        this.$message({
          message: "不能添加重复话题",
          type: "warning",
        });
      } else {
        this.topicOptions.forEach((item) => {
          if (item.id == this.topicValue) {
            this.topicList.push(item.title.replace(/#/gi, ""));
            this.topicIds.push(this.topicValue);
            this.insertTopicVisible = false;
          }
        });
      }
    },
    checkTopic(id) {
      return this.topicIds.indexOf(id) > -1;
    },
    deleteTopic(index) {
      this.$confirm("确定要删除该话题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.topicList.splice(index, 1);
          this.topicIds.splice(index, 1);
        })
        .catch(() => {});
    },
    getTopics(global_id) {
      this.$axios
        .get(
          `${NEWS_HOST}/api/hottopic/getTopicListByManuscriptId?global_id=${global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item) => {
              this.topicList.push(item.title.replace(/#/gi, ""));
              this.topicIds.push(item.id);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: {
          scriptId: item.nm_id,
          isMine: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    onBeforeUploadThumb(file) {
      const isImage = file.type.indexOf("image/") >= 0;
      if (!isImage) {
        this.$message.error("请上传图片！");
        return false;
      } else {
        return true;
      }
    },
    uploadThumbFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.collectionThumb = data.url;
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    onDragEnd() {
      //console.log(this.collectionList);
    },
    deleteCollect(index) {
      this.$confirm("确认把视频移除合集吗？", "移除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.collectionList.splice(index, 1);
        })
        .catch(() => {});
    },
    sortShow(index) {
      this.collectionList[index].indexChange = index + 1;
    },
    sortSubmit(item, index) {
      item.indexChange = parseInt(item.indexChange);
      if (item.indexChange < 1) {
        this.$message({
          message: "请输入正确的位数数字",
          type: "warning",
        });
      } else if (index + 1 > item.indexChange) {
        this.collectionList.splice(
          item.indexChange - 1,
          0,
          this.collectionList[index]
        );
        this.collectionList.splice(index + 1, 1);
        item.visible = false;
      } else {
        this.collectionList.splice(
          item.indexChange,
          0,
          this.collectionList[index]
        );
        this.collectionList.splice(index, 1);
        item.visible = false;
      }
    },
    openVideos() {
      this.currentAddKeyword = "";
      this.collectionAddKeyword = "";
      this.currentPage = 1;
      this.collectionAddChecks = JSON.parse(
        JSON.stringify(this.collectionList)
      );
      this.getVideoList();
      this.collectionAddVisible = true;

      this.$nextTick(() => {
        document.getElementsByClassName(
          "videoCollectContainer"
        )[0].scrollTop = 0;
      });
    },
    getVideoList(isSearch) {
      if (isSearch) {
        this.currentAddKeyword = this.collectionAddKeyword;
        this.currentPage = 1;
      }
      this.$axios
        .get(
          `${RESOURCE_HOST}/api/newsPack/getUserWaitVideoList?page=${this.currentPage}&size=${this.pageSize}&n_title=${this.currentAddKeyword}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.data.forEach((item) => {
              if (this.checkCollection(item.n_id) > -1) {
                item.checked = true;
              } else {
                item.checked = false;
              }
              item.indexChange = "";
              item.visible = false;
              item.n_cover_url = JSON.parse(item.n_cover_url);
            });
            this.collectionAddList = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getVideoList();

      document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
    },
    handleCheckVideo(val, item) {
      if (val) {
        if (this.checkCollection(item.n_id) < 0) {
          this.collectionAddChecks.unshift(item);
        }
      } else {
        if (this.checkCollection(item.n_id) > -1) {
          this.collectionAddChecks.splice(this.checkCollection(item.n_id), 1);
        }
      }
    },
    checkCollection(itemId) {
      let itemIndex = -1;
      this.collectionAddChecks.forEach((item, index) => {
        if (item.n_id == itemId) {
          itemIndex = index;
        }
      });
      return itemIndex;
    },
    addVideosFn() {
      this.collectionList = JSON.parse(
        JSON.stringify(this.collectionAddChecks)
      );
      this.collectionAddVisible = false;
    },
    submitCollection() {
      if (this.collectionTitle == "") {
        this.$message({
          message: "请输入合集标题",
          type: "warning",
        });
      } else if (
        this.collectionThumb.indexOf("dingnews.net") < 0 &&
        this.collectionThumb.indexOf("dingxinwen.com") < 0 &&
        this.collectionThumb.indexOf("dingxinwen.cn") < 0
      ) {
        this.$message({
          message: "请上传合集封面",
          type: "warning",
        });
      } else if (this.collectionList.length == 0) {
        this.$message({
          message: "请选择至少一个合集视频",
          type: "warning",
        });
      } else {
        let n_ids = [];
        this.collectionList.forEach((item) => {
          n_ids.push(item.n_id);
        });
        let request = {
          title: this.collectionTitle,
          cover_url: this.collectionThumb,
          n_ids: n_ids.join(","),
        };
        let url = `${RESOURCE_HOST}/api/newsPack/add`;
        if (this.belong_id_Pack) {
          request.nvpl_series_id = this.belong_id_Pack;
          url = `${RESOURCE_HOST}/api/newsPack/edit`;
        }
        this.$axios.post(url, request).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `${this.belong_id_Pack ? "编辑" : "创建"}成功`,
              type: "warning",
            });

            this.$router.push({
              path: "/personalScript",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    getCollectionDetail() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/api/newsPack/getDetail?nvpl_series_id=${this.belong_id_Pack}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.detail.forEach((item) => {
              item.indexChange = "";
              item.visible = false;
              if (typeof item.n_cover_url == "string") {
                item.n_cover_url = JSON.parse(item.n_cover_url);
              }
            });
            this.collectionTitle = res.data.data.title;
            this.collectionThumb = res.data.data.cover_url;
            this.collectionList = res.data.data.detail;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    aiTitleShowFn() {
      let clearContent = this.getClearContent();
      if (clearContent.length < 50) {
        this.$message({
          message: "正文内容必须大于等于50个字",
          type: "warning",
        });
      } else {
        this.aiTitle = ["", "", ""];
        this.aiTitleLoading = true;
        this.aiTitleShow = true;
        this.$axios
          .post(`${RESOURCE_HOST}/common/aiCreate/title`, {
            text: clearContent,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.aiTitle = res.data.data.title;
              this.aiTitleLoading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    aiTitleSelect(item) {
      this.title = item;
      this.aiTitleShow = false;
    },
    getClearContent() {
      return this.content
        .replace(/<[^<>]+>/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/\s/g, "");
    },
    toRights() {
      this.$router.push({
        path: "/rights",
      });
    },
    getRight(val) {
      this.collectionRight = val;
    },
  },
};
</script>

<style>
.el-tabs__nav-scroll {
  display: flex;
}

.el-tabs__nav-wrap::after {
  background: white;
}
.el-tabs__item.is-active {
  color: #333;
  font-weight: bold;
}
.el-input--suffix .el-input__inner {
  background: #f6f7f9;
  border: 0px;
}
.el-textarea__inner {
  background: #f6f7f9;
  border: 0px;
}
</style>

<style lang="scss" scoped>
.memberContainer {
  background: #edf1f8;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: scroll;

  .backBtn {
    width: 970px;
    margin: 0 auto;
    background-color: #fff;
    line-height: 40px;
    padding-left: 20px;
    color: #409eff;

    span {
      cursor: pointer;
    }

    .previewBtn {
      margin-left: 530px;
      display: inline-block;
    }
  }

  .innerContainerVideo {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    background: #edf1f8;

    /deep/.editContainer {
      margin: 20px auto 0 auto;
      background: white;
      position: relative;
      width: 856px;

      .tabContainer {
        width: calc(100% - 80px);
        display: flex;
        border-bottom: 1px solid #e5e6eb;
        margin-left: 40px;
        padding-top: 56px;

        .tabs {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 25px;
          margin-right: 40px;
          padding-bottom: 10px;
          cursor: pointer;
        }

        .tabs:last-child {
          margin-right: 0;
        }

        .tabActive {
          border-bottom: 2px solid #ea0e0e;
          font-weight: bold;
        }
      }

      .singleVideoContainer {
        padding: 15px 40px 30px 40px;
        position: relative;

        .coverChangeBtn {
          cursor: pointer;
          position: absolute;
          top: 30px;
          left: 50px;
          font-size: 14px;
          width: 88px;
          line-height: 32px;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-align: center;
          z-index: 1;
        }

        .get-cover {
          width: 100%;
          height: 436px;
          border: 1px solid #e8e8e8;
          background-color: #fcfcfc;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          position: relative;
        }
        .get-cover p {
          width: 100%;
          height: 24px;
          text-align: center;
          color: #bbb;
          margin-top: 0 !important;
          font-size: 18px;
        }
        .get-cover .tip {
          position: absolute;
          left: 0;
          bottom: -1px;
          font-size: 12px !important;
          color: #fff;
          width: 100%;
          line-height: 32px !important;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.32);
          border-radius: 4px;
        }
        .get-cover .videoIcon {
          width: 40px;
          height: 40px;
          min-height: 40px;
          position: absolute;
          left: 50%;
          top: 50%;
          margin: -20px 0 0 -20px !important;
        }
        .get-cover .videoCover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .horizontalThumb .videoCover {
          width: auto;
          height: 100%;
        }

        .titleContain {
          height: 70px;
          display: flex;
          border-top: 1px solid #e5e6eb;
          margin-top: 32px;
          padding-top: 32px;
          align-items: center;
        }

        .titleLabelContain {
          margin-right: 30px;

          .titleLabel {
            width: 70px;
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            font-weight: bold;
            text-align: right;
          }

          .titleAiOutBtn {
            width: 70px;
            cursor: pointer;
            background-color: #ffffff;
            color: #ea0e0e;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            margin-top: 4px;
            text-align: right;
          }
        }

        .contentContain {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 12px;
          margin-top: 32px;

          .titleLabel {
            width: 70px;
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: bold;
            text-align: right;
          }

          .topicBtn {
            width: 21px;
            cursor: pointer;
          }
        }
      }

      .el-textarea {
        margin: 0 0 10px 0;
      }

      .el-tabs {
        height: calc(100% - 275px);
      }

      .el-tabs__content {
        height: 100%;
      }

      .publicScroll {
        width: 100%;
        height: 436px;
        overflow-y: scroll;
        padding-right: 15px;
      }

      video {
        width: 100%;
        margin-bottom: 20px;
      }

      .uploadElemBox {
        width: 100%;
        height: 436px;

        .el-upload {
          /* background: #e2e2e2; */
          width: 100%;
          height: 100%;

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            background: #f6f7f9;
            border: 1px dashed #e2e2e2;

            p {
              font-size: 20px;
              color: #409eff;
              width: 100%;
              text-align: center;
            }
          }
        }

        .el-upload-list {
          display: none;
        }
      }

      .sourceList {
        display: flex;
        flex-wrap: wrap;
        padding-top: 5px;

        li {
          width: calc((100% - 40px) / 3);
          margin: 0 20px 10px 0;
          cursor: pointer;
          border: 2px solid #fff;

          .thumbContainer {
            width: 100%;
            height: 110px;
            position: relative;

            .thumb {
              width: 100%;
              height: 100%;
            }

            .timeMask {
              width: 100%;
              position: absolute;
              left: 0;
              bottom: 0;
            }

            p {
              position: absolute;
              left: 5px;
              bottom: 3px;
              font-size: 12px;
              color: #ffffff;
            }
          }

          .title {
            line-height: 18px;
            margin-top: 6px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        li:nth-child(3n) {
          margin-right: 0;
        }

        li.active {
          border: 2px solid #ea0e0e;
        }
      }

      .el-input__count,
      .el-input__count-inner {
        background-color: #f6f7f9;
      }

      .videoCollectionContainer {
        padding: 30px 40px 0 40px;
        position: relative;

        .collectionInputContainer {
          display: flex;
          align-items: center;

          .label {
            color: rgb(51, 51, 51);
            font-size: 14px;
            width: 100px;
            flex-shrink: 0;
            font-weight: bold;

            span {
              color: red;
              font-weight: bold;
            }
          }

          .el-input {
            margin-bottom: 0;
            margin-right: 0;
          }

          .thumbImgUploader {
            width: 165px;
            height: 124px;
          }

          .el-upload {
            width: 165px;
            height: 124px;
          }

          .thumbImg {
            width: 165px;
            height: 124px;
            cursor: pointer;
            object-fit: cover;
          }

          .submitBtn {
            width: 122px;
            border: 1px solid #dcdfe6;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
            border-radius: 4px;
            color: #333;
            line-height: 36px;
            display: inline-block;
          }
        }

        .thumbAlert {
          font-size: 12px;
          color: #999999;
          line-height: 20px;
          margin: 8px 0 32px 100px;
        }

        .scriptList {
          border-top: 1px solid #edf1f8;
          padding: 16px 0 189px 0;
          margin-top: 32px;

          .scriptListItem {
            border-bottom: 1px solid #edf1f8;
            padding: 16px 0;
            display: flex;
            min-height: 90px;
            box-sizing: content-box;

            .cover-container {
              width: 160px;
              height: 90px;
              border-radius: 6px;
              overflow: hidden;
              background: #ccc;
              margin-right: 20px;

              .cover {
                height: 100%;
                width: 100%;
              }
            }

            .info-box {
              flex: 1;
              position: relative;

              .infoContainer {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .title {
                  width: calc(100% - 180px);
                  text-overflow: ellipsis;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  color: #333333;
                  font-weight: bold;
                  font-size: 16px;
                  cursor: pointer;
                  line-height: 20px;
                }

                .create-time {
                  color: #999999;
                  font-size: 14px;
                }

                .actionContainer {
                  display: flex;
                  line-height: 30px;

                  .btns {
                    margin-left: 20px;
                    color: #5574e7;
                    font-size: 14px;
                    cursor: pointer;
                  }
                }
              }

              .infoContainer.action-bar {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 100%;

                .ext-info {
                  color: #999999;
                  span {
                    margin-right: 20px;
                  }
                }
                .actionContainer {
                  flex: 1;
                  justify-content: flex-end;
                }
              }
            }
          }

          .scriptListItem:last-child {
            border-bottom: 0;
          }
        }

        .collectionSubmitContainer {
          width: 100%;
          position: fixed;
          left: 0;
          bottom: 0;
          background-color: #ffffff;
          box-shadow: 0 1px 4px rgba(0, 21, 41, 0.12);
          height: 72px;

          .collectionSubmitContainerInner {
            width: 856px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }

          .submitBtn {
            width: 122px;
            height: 36px;
            display: block;
          }
        }
      }

      .noCollectionRight {
        padding: 40px 60px 240px 60px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .noRightIcon {
          width: 182px;
          margin-top: 177px;
        }

        .rightWarning {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          margin-top: 39px;
        }

        .toRights {
          color: #ea0e0e;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          margin-top: 7px;
          cursor: pointer;
        }
      }
    }
    .topicListContainer {
      display: flex;
      flex-wrap: wrap;
      margin: 0 0 10px 0;

      .topicList {
        margin-right: 20px;
        font-size: 14px;
        color: #1687d9;
        cursor: pointer;
      }
    }
  }

  /deep/.collectionAddContainer {
    .el-dialog {
      height: 86vh;

      .el-dialog__body {
        padding-top: 10px;
      }

      .collectionAddKeyword {
        width: 350px;
        margin-bottom: 15px;
      }

      .searchNoDataContainer {
        width: 100%;
        height: calc(86vh - 245px);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .noDataText {
          margin-top: 21px;
          font-size: 20px;
          color: rgb(204, 204, 204);
        }
      }

      .videoCollectContainer {
        width: 100%;
        max-height: calc(86vh - 245px);
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;

        .scriptListItem {
          width: calc(50% - 15px);
          padding: 8px 0;
          display: flex;
          height: 110px;
          box-sizing: content-box;
          margin-right: 15px;

          .el-checkbox {
            margin: 0 10px 0 0;
            display: flex;
            align-items: center;
          }

          .bgContainer {
            width: calc(100% - 29px);
            background-color: #f6f7f9;
            display: flex;
            padding: 10px;
            border-radius: 5px;
          }

          .cover-container {
            width: 160px;
            height: 90px;
            border-radius: 6px;
            overflow: hidden;
            background: #ccc;
            margin-right: 10px;
            flex-shrink: 0;

            .cover {
              height: 100%;
              width: 100%;
            }
          }

          .info-box {
            flex: 1;
            position: relative;
            width: calc(100% - 210px);

            .title {
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              color: #333333;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
              line-height: 20px;
              height: 40px;
              margin-bottom: 13px;
            }
          }

          .create-time {
            color: #999999;
            font-size: 14px;
          }

          .infoContainer.action-bar {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;

            .ext-info {
              color: #999999;
              span {
                margin-right: 10px;
              }
            }
            .actionContainer {
              flex: 1;
              justify-content: flex-end;
            }
          }
        }
      }

      .el-dialog__footer {
        margin-top: 10px;
      }
    }
  }

  /deep/.previewContainer {
    .el-dialog {
      background: url(../../assets/script/preview.png) no-repeat;
      background-size: 100% 100%;
      height: 670px;
      border-radius: 40px;
      padding-top: 70px;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      height: 519px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      padding-left: 22px;
      padding-right: 22px;
      overflow-y: scroll;

      .closeBtn {
        position: absolute;
        top: 0;
        left: 332px;
        height: 32px;
        cursor: pointer;
      }

      video {
        width: 100%;
        max-height: 210px;
        margin: 10px auto 10px auto;
        height: auto;
      }

      .info {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          margin-right: 20px;
        }

        .userName {
          font-size: 14px;
          line-height: 20px;
        }

        .time {
          line-height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }

      .title {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 31px;
        margin-bottom: 5px;
      }
    }
  }

  /deep/.insertTopicContainer {
    .el-dialog__body {
      padding-bottom: 10px;
      padding-top: 10px;
    }
    .el-select {
      width: 100%;
    }
    .el-input {
      width: 100%;
      margin-bottom: 0;
    }
    .el-input__inner {
      width: 100%;
    }
    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  /deep/.videoCoverContainer {
    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0 0 0 0;

      .videoCoverTabs {
        display: flex;
        border-bottom: 1px solid #ebebeb;

        .videoCoverTab {
          cursor: pointer;
          margin-left: 28px;
          font-weight: normal;
          color: #161616;
          line-height: 64px;
          font-size: 18px;
        }
      }

      .videoCoverTabActive {
        border-bottom: 3px solid #fd595c;
      }

      .videoCutCoverContainer {
        height: 50vh;
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 0 28px;

        .videoCutCoverBox {
          padding: 2px;
          width: 212px;
          margin: 28px 28px 0 0;
          cursor: pointer;
          border: 2px solid #ffffff;

          .el-image {
            display: block;
          }
        }

        .videoCutCoverActive {
          border: 2px solid #ea0e0e;
        }
      }

      .videoUploadCoverContainer {
        height: 50vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .uploadText {
          font-size: 16px;
          margin-top: 20px;
        }

        .uploadVideoCoverBox {
          width: 500px;
          height: 281px;

          .el-upload {
            width: 100%;
            height: 100%;
          }

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .uploadIcon {
              height: 89px;
            }

            .videoCoverUpload {
              max-height: 100%;
              max-width: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    .el-dialog__footer {
      padding-top: 20px;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  .thumbCutContainer {
    /deep/.el-dialog__body {
      padding-bottom: 10px;
      padding-top: 0;

      .avatar-uploader {
        background: red !important;
        width: 150px;
        height: 150px;
        text-align: center;
        line-height: 150px;
      }

      .el-icon-plus {
        width: 150px;
        height: 150px;
        font-size: 30px;
      }

      .cropper-content {
        width: 100%;
        height: 700px;
        background: pink;
      }

      .cropper {
        width: 100%;
        height: 700px;
        background: yellow;
      }

      .cropper-modal {
        background: rgba(0, 0, 0, 0.2) !important;
      }

      .cropper-view-box {
        img {
          display: none;
        }
      }
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }
}

.tinymce-upload-progress-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 10000;
}

/deep/.tinymce-upload-progress {
  z-index: 10001;
}

.tinymce-upload-progress {
  position: absolute !important;
  text-align: center;
  display: none;
  top: 50%;
  left: 50%;
  margin-top: -62px !important;
  margin-left: -60px !important;
}

.titleAiContain {
  padding: 20px;
  margin-left: -54px;
  margin-top: 18px !important;

  .aiTitleList {
    .aiTitleItem {
      display: flex;
      background: #f7f8f9;
      padding: 10px 12px;
      margin-top: 12px;
      color: #666666;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;

      .aiTitleLabel {
      }

      .aiTitleContent {
        flex: 1;
      }
    }

    .aiTitleItem:first-child {
      margin-top: 0;
    }

    .aiTitleItem:hover {
      color: #ea0e0e;
    }
  }
}
</style>
